/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback, useMemo } from 'react'
import { withTranslation } from 'react-i18next'
import styles from '../JointlyOwnedVehicleInformation.module.scss'
import { useHistory } from 'react-router-dom'
import BackAnchor from 'shared/components/BackAnchor'
import AddJointlyOwnedVehicleView from './AddJointlyOwnedVehicleView'
import JointlyOwnedVehicleListTable from './JointlyOwnedVehicleListTable'
import { useDispatch, useSelector } from 'react-redux'
import { setEditJointMasterNumber } from 'redux/actions';

const JointlyOwnedVehicleSummaryView = ({ t, i18n, setIsError }) => {
  let history = useHistory()
  const dispatch = useDispatch();

  const { registeredBusiness } = useSelector((state) => state.app.addressTypeChange);
  const { editMasterNumber } = useSelector((state) => state.app.jointlyOwnedVehicleInformation);
  const nextRoute = useMemo(() => {
    if (registeredBusiness) {
      return t('routes.business_vehicle_info');
    }
    return t('routes.addresses_to_change');
  }, [registeredBusiness, t]);

  const onNextClick = () => {
    try {
      history.push(`/${i18n.language}${nextRoute}`)
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const onBackClick = useCallback(() => {
    dispatch(setEditJointMasterNumber(editMasterNumber));
  }, [editMasterNumber, dispatch])

  return (
    <div>
      <div className="container">
        <div className="row">
          <BackAnchor onBackClick={onBackClick} />
        </div>
        <div className="row">
          <div className="col-xs-12">
            <h1>{t('jointly_owned_vehicle_summary.title')}</h1>
          </div>
        </div>
        <JointlyOwnedVehicleListTable setIsError={setIsError} />
        <div className="row">
          <div className="col-xs-12 col-lg-8">
            <button
              className={['btn-lg btn-default', styles['next-button']].join(' ')}
              onClick={onNextClick}
              value={t('jointly_owned_vehicle_summary.next')}
              name={t('jointly_owned_vehicle_summary.next')}
            >
              {t('jointly_owned_vehicle_summary.next')}
            </button>
          </div>

        </div>
        <div>
          <AddJointlyOwnedVehicleView t={t} setIsError={setIsError} />
        </div>
      </div>
    </div>
  )
}

export default withTranslation('common')(JointlyOwnedVehicleSummaryView)
